// extracted by extract-css-chunks-webpack-plugin
module.exports = {"box":"box-2aBCOuy1","footer":"footer-1TtIy8dI","right_link":"right_link-18K7t_Jw","f_ico1":"f_ico1-3__FMIHg","v_dellink":"v_dellink-3ZlFHaIk"};